/*
 * toggleSwitch
 */

$(function () {
  toggleSwitch.init();
});
var toggleSwitch = (function () {
  return {
    init: function () {
      $("[data-role='toggleSwitch']").each(function () {
        $(this).on('click', function (e) {
          console.log("click");
          e.preventDefault();
          $(this).toggleClass('active');
          $(this).siblings("[data-role='toggleTarget']").toggleClass('active');
        });
      });
    },
  };
})();